<div class="annual-income"><h1>{{ $t("property_page.annual_income_graph") }}</h1><div class="chart-wrapper"><div id="annual-income-chart"></div></div></div>